var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 56,
    viewBox: "0 0 73 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43648 34.7306C5.43648 34.7306 9.79281 31.0227 11.5252 31.2179C15.4358 31.6633 30.4054 41.8324 33.2732 43.5082C36.1662 45.1924 35.8845 52.2858 35.8845 52.2858C35.8845 52.2858 40.245 54.9288 45.3204 55.5355C48.554 55.9215 51.8086 55.0306 54.5376 53.2445L70.1296 43.0415C70.7519 42.6555 72.3792 41.3785 72.4212 40.1227L72.5348 27.8409C72.5979 25.9488 71.7863 25.0961 70.3692 24.2603L29.8335 0.400909C28.9421 -0.133636 27.874 -0.133636 26.9826 0.400909L3.51062 14.4773C2.58132 15.0288 2.00524 16.0894 2.00945 17.1755L0.0583547 29.0882C-0.656486 31.2179 5.43228 34.7306 5.43228 34.7306H5.43648Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo-2.fc0c786d86ce1064d569a98379b60200.svg";
export { ForwardRef as ReactComponent };